/*
 *
 * Theme for application.
 * Individual styles should use the variables defined here.
 *
 */

export const cocoas = {
    cocoa0: '#F8F7F5',
    cocoa100: '#E5E4E1',
    cocoa200: '#CECAC6',
    cocoa300: '#B7B0AC',
    cocoa400: '#A09793',
    cocoa500: '#897E7B',
    cocoa600: '#716664',
    cocoa700: '#5A4F4E',
    cocoa800: '#433938',
    cocoa900: '#2C2424',
    cocoa950: '#1D1919', // Use for Background Gradient Color
    cocoa1000: '#0D0D0D',
};

export const golds = {
    gold0: '#FFF6EB',
    gold100: '#E3C9AC',
    gold200: '#C7A37B',
    gold300: '#AB845A',
    gold400: '#946A3E',
    gold500: '#7D552B',
    gold600: '#66431E',
    brownishTan: '#B48D5C',
};

export const greens = {
    green0: '#EBFFF3',
    green100: '#AEE1B4',
    green200: '#63C67A',
    green300: '#32AB5B',
    green400: '#16904B',
    green500: '#077440',
    green600: '#005936',
};

export const reds = {
    red0: '#FCECEB',
    red100: '#DE9A96',
    red200: '#C65B57',
    red300: '#B03731',
    red400: '#9C251E',
    red500: '#881C14',
    red600: '#75140E',
};

export const gray = { gray0: '#f8f7f5', gray1: '#3d3634', gray2: '#2f2a28' };

export const seafoams = {
    seafoam0: '#E8FFFF',
    seafoam100: '#BCEDED',
    seafoam200: '#6AC9CD',
    seafoam300: '#35A3AD',
    seafoam400: '#17818D',
    seafoam500: '#07606D',
    seafoam600: '#00424D',
};

export const purples = {
    purple0: '#F5EBFF',
    purple100: '#CEADE3',
    purple200: '#B17CC8',
    purple300: '#9859AC',
    purple400: '#814291',
    purple500: '#693175',
    purple600: '#502459',
};

const chartreuse = {
    chartreuse200: '#E9FFBB',
};

const slate = {
    slate0: '#E8F1FF',
};

export const blues = {
    blue600: '#155DFC',
    blue800: '#193CB8',
};

export const colors = {
    ...cocoas,
    ...golds,
    ...gray,
    ...greens,
    ...reds,
    ...seafoams,
    ...purples,
    ...chartreuse,
    ...slate,
    ...blues,
};

export const alpha = {
    15: '26',
    20: '33',
    50: '80',
};

export const scale = {
    maxPageWidth: '1600px',
    navHeight: '54px',
    formInputHeight: '32px',
};
